<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Update Location</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">Form update location</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-body">
              <form @submit="update">
                <div class="row">
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
                    <label for="inputLocationName" class="form-label">
                      Location Name
                    </label>
                    <input
                      type="text"
                      v-model="data.location_name"
                      class="form-control"
                      id="inputLocationName"
                      placeholder="Location Name"
                    />
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
                    <label for="inputGatheringPoint" class="form-label">
                      Mustering Point
                    </label>
                    <input
                      type="text"
                      v-model="data.gathering_point"
                      class="form-control"
                      id="inputGatheringPoint"
                      placeholder="Mustering Point"
                    />
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
                    <label for="inputLocationName" class="form-label">
                      Location Type
                    </label>
                    <v-select
                      v-model="data.type"
                      :options="types"
                      label="label"
                      :reduce="(e) => e.value"
                    />
                  </div>
                  <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
                    <label for="inputLocationName" class="form-label">
                      Location Color
                    </label>
                    <div class="d-flex">
                      <input
                        style="width: 100px"
                        type="color"
                        v-model="data.color"
                        class="form-control"
                      />
                      <input
                        type="text"
                        v-model="data.color"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <template v-if="data.type">
                    <div class="col-12 col-xl-12 mb-3">
                      <label for="inputLocationName" class="form-label"
                        >Set your point ({{ data.type }})</label
                      >
                      <l-map
                        v-if="data.type === 'area'"
                        style="height: 500px"
                        :zoom="zoom"
                        :center="center"
                        @click="setArea"
                      >
                        <l-tile-layer
                          :url="url"
                          :attribution="attribution"
                        ></l-tile-layer>
                        <l-circle
                          v-for="(item, i) in area"
                          :key="i"
                          :lat-lng="item.center"
                          :radius="item.radius"
                          :color="data.color"
                        />
                      </l-map>

                      <l-map
                        v-else-if="data.type === 'polygon'"
                        style="height: 500px"
                        :zoom="zoom"
                        :center="center"
                        @click="setPolygon"
                      >
                        <l-tile-layer
                          :url="url"
                          :attribution="attribution"
                        ></l-tile-layer>
                        <l-polygon
                          :lat-lngs="polygon"
                          :color="data.color"
                        ></l-polygon>
                      </l-map>
                    </div>
                    <div class="col-12 col-xl-12">
                      <label class="form-label">Settings</label>
                      <div class="w-100 overflow-auto">
                        <div class="d-flex mb-3">
                          <div class="w-100 mr-2">
                            <label>Latitude</label>
                            <input
                              type="text"
                              v-model="latitude"
                              class="form-control mr-2"
                            />
                          </div>
                          <div class="w-100 mr-2">
                            <label>Longitude</label>
                            <input
                              type="text"
                              v-model="longitude"
                              class="form-control mr-2"
                            />
                          </div>
                          <div class="w-100">
                            <button
                              class="btn btn-success w-100 mt-4"
                              @click.prevent="addManual(data.type)"
                            >
                              Add Manual
                            </button>
                          </div>
                        </div>
                        <table
                          class="table table-bordered"
                          v-if="data.type === 'area'"
                        >
                          <thead>
                            <tr class="text-center">
                              <th></th>
                              <th>Latitude</th>
                              <th>Longitude</th>
                              <th>Radius/M</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="text-center"
                              v-for="(item, i) in area"
                              :key="i"
                            >
                              <td>
                                <i
                                  class="fe fe-x-circle text-danger"
                                  @click.prevent="deleteArea(i)"
                                ></i>
                              </td>
                              <td>{{ item.center[0] }}</td>
                              <td>{{ item.center[1] }}</td>
                              <td>
                                <input
                                  type="number"
                                  :value="item.radius"
                                  class="form-control"
                                  @input="(e) => changeRadius(e, i)"
                                />
                              </td>
                            </tr>
                            <tr v-if="area.length <= 0" class="text-center">
                              <td colspan="4" class="text-muted">
                                Please set point on map
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          class="table table-bordered"
                          v-else-if="data.type === 'polygon'"
                        >
                          <thead>
                            <tr class="text-center">
                              <th></th>
                              <th>Latitude</th>
                              <th>Longitude</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(item, i) in polygon">
                              <tr
                                class="text-center"
                                :key="i"
                                v-if="i !== polygon.length - 1"
                              >
                                <td>
                                  <i
                                    class="fe fe-x-circle text-danger"
                                    @click.prevent="deletePolygon(i)"
                                  ></i>
                                </td>
                                <td>{{ item[0] }}</td>
                                <td>{{ item[1] }}</td>
                              </tr>
                            </template>
                            <tr v-if="polygon.length <= 0" class="text-center">
                              <td colspan="3" class="text-muted">
                                Please set point on map
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center">
                      <div class="alert alert-light" role="alert">
                        Please select location type
                      </div>
                    </div>
                  </template>
                  <div class="col-12">
                    <div class="d-flex">
                      <button
                        class="btn btn-warning ms-auto"
                        @click.prevent="update"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";

export default {
  name: "locationComponent",
  computed: {
    detail() {
      return JSON.parse(JSON.stringify(this.$store.getters["location/detail"]));
    },
  },
  data() {
    return {
      edited: null,
      zoom: 5,
      polygon: [[]],
      latitude: "",
      longitude: "",
      area: [],
      types: [
        {
          label: "Area",
          value: "area",
        },
        {
          label: "Polygon",
          value: "polygon",
        },
      ],
      data: {
        location_name: "",
        gathering_point: "",
        type: "",
        color: "#ff0000",
        geolocation: [],
      },
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 9,
      center: [-3.70125098, 115.55964685],
      circle: {
        center: [47.41322, -1.0482],
        radius: 4500,
        color: "red",
      },
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      const id = this.$router.currentRoute.params["id"];
      this.$store.dispatch("location/DETAIL", { id }).then(() => {
        const detail = this.detail;
        const type = this.detail.type;
        this.data.location_name = detail.location_name;
        this.data.gathering_point = detail.gathering_point;
        this.data.type = type;
        this.data.color = detail.color;
        if (type === "area") {
          console.log(this.detail.geolocation);
          this.area = [
            {
              center: this.detail.geolocation[0],
              radius: this.detail.radius,
            },
          ];
          this.center = this.detail.geolocation[0];
        } else if (type === "polygon") {
          this.polygon = this.detail.geolocation;
          this.center = this.detail.geolocation[0];
        }
      });
    },
    addManual(type) {
      const map = {
        latlng: {
          lat: this.latitude,
          lng: this.longitude,
        },
      };

      if (type === "polygon") {
        this.setPolygon(map);
      } else {
        this.setArea(map);
      }

      this.latitude = "";
      this.longitude = "";
    },
    setPolygon(map) {
      try {
        const latlng = map.latlng;
        const lat = latlng.lat;
        const lng = latlng.lng;

        if (this.polygon.length > 1) {
          this.polygon.splice(this.polygon.length - 1, 1);
        }
        this.polygon.push([lat, lng]);
        this.polygon.push(this.polygon[0]);
      } catch (err) {
        console.log(err);
      }
    },
    setArea(map) {
      const latlng = map.latlng;
      const lat = latlng.lat;
      const lng = latlng.lng;
      this.area = [];
      this.area.push({ center: [lat, lng], radius: 10 });
    },
    deleteArea(i) {
      this.area.splice(i, 1);
    },
    deletePolygon(i) {
      this.polygon.splice(i, 1);
      if (this.polygon.length === 1) {
        this.polygon.splice(0, 1);
      }

      if (i === 0) {
        this.polygon[this.polygon.length - 1] = this.polygon[0];
      }
    },
    changeRadius(e, i) {
      const value = Number(e.target.value);
      const radius = {
        radius: value,
      };
      this.area[i].radius = value;
    },
    update() {
      this.$swal({
        title: "Are you sure?",
        text: "This Update Will Change Location of Map!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, updated it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const id = this.$router.currentRoute.params["id"];
          const payload = this.data;
          if (payload.type === "area") {
            const position = this.area[0].center;
            payload.geolocation = [position];
          } else if (payload.type === "polygon") {
            const polygon = this.polygon;
            payload.geolocation = polygon;
          } else {
            return false;
          }

          payload["id"] = this.detail.id;
          if (this.area.length > 0) {
            const radius = this.area[0].radius;
            payload["radius"] = radius;
          } else {
            payload["radius"] = 0;
          }

          this.$store.dispatch("location/UPDATE", { id, payload }).then(() => {
            this.$swal("Updated", "Location Updated", "success");
            this.$router.push("/location");
          });
        }
      });
    },
  },
};
</script>
